import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {SmsContainerDto} from "../getSmsList";

export async function postSmsList(smsGroup: SmsContainerDto) {
    const response = await axios.post<BaseResponse<string>>("/sms", smsGroup)

    return response.data
}
